//
// Copyright (c) 2026 Comcast
//

import { createSlice } from '@reduxjs/toolkit'
import { locationChanged } from 'reducers/routing'

const initialState = {
  isFeedbackSidebarFormVisible: false,
}

export const feedbackSlice = createSlice({
  name: 'feedback',
  initialState,

  reducers: {
    showSidebarForm: (state, action) => {
      state.isFeedbackSidebarFormVisible = true
    },

    hideSidebarForm: (state, action) => {
      state.isFeedbackSidebarFormVisible = false
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(locationChanged, (state, action) => {
        state.isFeedbackSidebarFormVisible = false
      })
  },
})

export const {
  showSidebarForm,
  hideSidebarForm,
} = feedbackSlice.actions

export default feedbackSlice.reducer
